import { toCurrency } from '@Helpers';

import { Offer } from '@App/interfaces/offer';
import Legal from '@Components/Legal/Legal';
import { getRateType } from '@Shared/helpers/offer';

interface RateCardDetailsProps {
    offer: Offer;
}

export const RateCardDetails = ({ offer }: RateCardDetailsProps) => {
    const rateInfoValues = [
        { label: 'Rate type', value: getRateType(offer) },
        { label: 'Product', value: offer.family },
        {
            label: 'Total cost of loan',
            value: `£${toCurrency(offer.totalAmountRepaid)}`,
        },
    ];

    return (
        <div className='pb-3 text-md'>
            {rateInfoValues.map((item) => (
                <div className='flex gap-2 bg-monochrome-100 p-3 text-sm rounded-t mb-0.5'>
                    <p>{item.label}</p>
                    <div className='flex-1 h-0 mt-3'></div>
                    <p className='font-sora-bold text-midnight-200'>
                        {item.value}
                    </p>
                </div>
            ))}

            <Legal className='mt-3 leading-120%' offer={offer} showAPRC />
        </div>
    );
};
